import { FC, useContext } from 'react'
import { Position } from '../../types'
import { InternalContext } from '../contexts/InternalContext'
import PlayTo from '../../components/icons/PlayTo'
import { CutterContext } from '../contexts/CutterContext'
import SvgPlay from '../../components/icons/Play'
import './ActionsSelectionPosition.scss'
import { ActionsSelectionButton } from './ActionsSelectionButton'
import { RangeEdge } from '../../enums/RangeEdge'

interface Props {
  position: Position
  end?: Position
  edge: RangeEdge
}

export const ActionsSelectionPosition: FC<Props> = ({ position, end, edge }) => {
  const {
    audioPlayer: { play },
  } = useContext(InternalContext)
  const {
    audio,
    audioBuffer: { sampleRate },
  } = useContext(CutterContext)

  return (
    <div className="ActionsSelectionPosition">
      {position > 0 && (
        <ActionsSelectionButton
          play={() => play([Math.max(0, position - 1 * sampleRate), position])}
          icon={<PlayTo />}
          title="Play 1 second before"
          edge={edge}
          direction="before"
        />
      )}

      {position < audio.length && (
        <ActionsSelectionButton
          play={() => play(end ? [position, end] : position)}
          icon={<SvgPlay />}
          title="Play after the position"
          edge={edge}
          direction="after"
        />
      )}
    </div>
  )
}
